import { useStore } from '../store';


export default class AiService {
    constructor() {
        const { jira } = useStore();
        this.jira = jira;
    }

    suitePrompts() {
      return [
        {   
            label: 'Suggest Tests',
            prompt: 'suggest_new_tests',
            description: 'Generate new test cases based on the patterns and structure of existing tests in this suite.',
        },
        {
            label: 'Summarize',
            prompt: 'suite_summary',
            description: 'Generate a concise summary of the test suite, highlighting key features, test coverage, and any notable findings.',
        }
      ]
    }

  testPrompts(model) {
    return [
      {   
          label: 'Suggest Description',
          prompt: 'suggest_test_description',
          description: 'Generate a clear and concise description for a test based on its title and a list of descriptions from similar tests.',
          when: () => !model.description,
          tooltip: 'Description is not empty',
      },
      {
          label: 'Improve Description',
          prompt: 'improve_test_description',
          when: () => !!model.description,
          tooltip: 'Description is empty',
      },
      {
          label: 'Suggest Better Description',
          prompt: 'suggest_test_description',
          when: () => !!model.description,
          tooltip: 'Description is empty',
      },
    ]
  }

    async getPrompts({type, id, prompt}) {
      try {
        const response = await this.jira.testomatioRequest(`/prompts`, { 
          method: 'POST',
          body: JSON.stringify({
              prompt,
              [`${type}_id`]: id
          })
        })
        return response;
      } catch (error) {
        //
      }
       
    }

    async createItem(item) {
      const data = {};

      if (item.type === 'test') {
        const [parentType, parentId] = item.parent.split(':');
          if (parentType === 'suite' && parentId) {
              data.relationships = {
                  suite: {
                      data: {
                          type: 'suites',
                          id: parentId
                      }
                  }
              }
          }

          data.type = 'tests';
          data.attributes = {
            title: item.title,
            sync: true,
            suite_id: parentId,
          }
      }
      try {
        const response = await this.jira.testomatioRequest('/tests', {
          method: 'POST',
          success: `${item.type} was created`,
          body: JSON.stringify({ data }),
        });
        return response;
      } catch (error) {
        //
      }
    }      
}